export default function ServiceHero() {
  return (
    <section className="relative h-96 flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a97177d0280e50961aa0c18a9e80531b.jpg"
          alt="KaliKare Services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-6xl font-bold text-white mb-6">Our Services</h1>
        <p className="text-xl text-white/95 max-w-3xl mx-auto leading-relaxed">
          Comprehensive home care solutions tailored to your unique needs. Our dedicated team provides compassionate, professional care that helps you or your loved ones maintain independence and dignity at home.
        </p>
      </div>
    </section>
  );
}
